/* BUGA — progressive motion layer. Horizon keeps control of navigation/view transitions. */
(()=>{const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;const reveal=()=>{const nodes=[...document.querySelectorAll('[data-buga-reveal]')];if(!nodes.length)return;if(reduceMotion||!('IntersectionObserver'in window)){nodes.forEach(node=>node.classList.add('is-visible'));return}const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target)}})},{rootMargin:'0px 0px -8% 0px',threshold:.08});nodes.forEach(node=>observer.observe(node))};const init=()=>{reveal();document.documentElement.classList.add('buga-ready')};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init,{once:true})}else{init()}document.addEventListener('shopify:section:load',init)})();

/* BUGA — empty cart: force a normal navigation only for the Continue shopping button. */
(()=>{
  document.addEventListener('click',(event)=>{
    if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!(event.target instanceof Element))return;
    const link=event.target.closest('.cart-items__empty-button');
    if(!(link instanceof HTMLAnchorElement))return;
    event.preventDefault();
    if(!document.querySelector('style[data-buga-empty-cart-transition-fix]')){
      const style=document.createElement('style');
      style.setAttribute('data-buga-empty-cart-transition-fix','');
      style.textContent='@view-transition { navigation: none; }';
      (document.head||document.documentElement).appendChild(style);
    }
    requestAnimationFrame(()=>window.location.assign(link.href));
  },{capture:true});
})();

/* BUGA — mobile menu: force reliable normal navigation for internal drawer links only. */
(()=>{
  const mobileMenu=window.matchMedia('(max-width: 749px)');

  document.addEventListener('click',(event)=>{
    if(!mobileMenu.matches||event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!(event.target instanceof Element))return;

    const link=event.target.closest('.header-drawer--mobile a[href], .menu-drawer a[href]');
    if(!(link instanceof HTMLAnchorElement))return;
    if(link.target&&link.target!=='_self')return;

    const url=new URL(link.href,window.location.href);
    if(!/^https?:$/.test(url.protocol)||url.origin!==window.location.origin)return;

    event.preventDefault();

    if(!document.querySelector('style[data-buga-mobile-menu-transition-fix]')){
      const style=document.createElement('style');
      style.setAttribute('data-buga-mobile-menu-transition-fix','');
      style.textContent='@view-transition { navigation: none; }';
      (document.head||document.documentElement).appendChild(style);
    }

    requestAnimationFrame(()=>window.location.assign(url.href));
  },{capture:true});
})();
